import {Modal} from "antd";
import React from "react";

export const DatasetChangeWarningModal = ({
  visible,
  onOk,
  onCancel
}: {
  visible: boolean;
  onOk: () => void;
  onCancel: () => void;
}) => {
  return (
    <Modal
      open={visible}
      onOk={onOk}
      onCancel={onCancel}
    >
      <p>
        Changing the dataset will reset your validation and analytics.
        Continue?
      </p>
    </Modal>
  );
};
